import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import store from '@/store';
import { translate } from '@/i18n';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  modalController,
} from '@ionic/vue';
import { closeOutline, saveOutline } from 'ionicons/icons';
import { onMounted, ref } from 'vue';
import { showToast } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: ["accountType", "systemMessageRemoteId"],
  setup(__props) {

const props = __props



const netSuiteMappinglist = ref([]);
const netsuiteRmaMap = ref({
  systemMessageRemoteId: props.systemMessageRemoteId,
  enumId: '',
  mappingValue: '',
});

onMounted(async() => {
  await getNetSuiteRMATypeMapping()
})

async function getNetSuiteRMATypeMapping() {
  const response = await store.dispatch('user/getNetSuiteRMATypeMapping');
  if (response) {
    netSuiteMappinglist.value = response.enumList
  }
}

const cancel = () => modalController.dismiss(null, 'cancel');
const confirm = () => {
  if (!netsuiteRmaMap.value.enumId.trim() || !netsuiteRmaMap.value.mappingValue.trim()) {
    showToast(translate("Please fill in all fields before saving."));
    return;
  } else {
    modalController.dismiss(netsuiteRmaMap.value, 'save');
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  color: "medium",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)(props.accountType == "sandbox" ? "Add NetSuite Sandbox RMA mapping" : "Add NetSuite Production RMA mapping")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSelect), {
              label: "Select Mapping Type",
              modelValue: netsuiteRmaMap.value.enumId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((netsuiteRmaMap.value.enumId) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(netSuiteMappinglist.value, (mapping) => {
                  return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                    key: mapping.enumId,
                    value: mapping.enumId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(mapping.description), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('NetSuite mapping values'),
              modelValue: netsuiteRmaMap.value.mappingValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((netsuiteRmaMap.value.mappingValue) = $event)),
              type: "number",
              required: ""
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonFab), {
          horizontal: "end",
          vertical: "bottom",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), { onClick: confirm }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})